export const FETCH_BODY_PARTS = "FETCH_BODY_PARTS";
export const FETCH_BODY_PARTS_START = "FETCH_BODY_PARTS_START";
export const FETCH_BODY_PARTS_SUCCESS = "FETCH_BODY_PARTS_START_SUCCESS";
export const FETCH_BODY_PARTS_ERROR = "FETCH_BODY_PARTS_ERROR";

export const fetchAllBodyParts = () => {
    return {
        type: FETCH_BODY_PARTS,
        payload: null
    }
}